export const animals = ["Adelie"
    , "Affenpinscher"
    , "Hound"
    , "Bush Elephant"
    , "Forest Elephant"
    , "Civet"
    , "Elephant"
    , "Penguin"
    , "Tree Toad"
    , "Ainu"
    , "Akbash"
    , "Akita"
    , "Malamute"
    , "Albatross"
    , "Alligator"
    , "Dachsbracke"
    , "Bulldog"
    , "Foxhound"
    , "Angelfish"
    , "Ant"
    , "Anteater"
    , "Antelope"
    , "Appenzeller"
    , "Fox"
    , "Hare"
    , "Wolf"
    , "Armadillo"
    , "Asian Elephant"
    , "Cattle Dog"
    , "Kelpie Dog"
    , "Mist"
    , "Shepherd"
    , "Terrier"
    , "Avocet"
    , "Axolotl"
    , "Baboon"
    , "Camel"
    , "Badger"
    , "Balinese"
    , "Bandicoot"
    , "Barb"
    , "Barn Owl"
    , "Barnacle"
    , "Barracuda"
    , "Basenji"
    , "Basking"
    , "Bat"
    , "Beagle"
    , "Bear"
    , "Collie"
    , "Bearded Dragon"
    , "Beaver"
    , "Beetle"
    , "Bengal Tiger"
    , "Bichon"
    , "Binturong"
    , "Bird"
    , "Birman"
    , "Bison"
    , "Black Bear"
    , "Rhinoceros"
    , "Bloodhound"
    , "Blue Whale"
    , "Bluetick"
    , "Bobcat"
    , "Bolognese"
    , "Bombay"
    , "Bongo"
    , "Bonobo"
    , "Booby"
    , "Border Collie"
    , "Orangutan"
    , "Borneo Elephant"
    , "Boxer Dog"
    , "Boykin"
    , "Brown Bear"
    , "Budgerigar"
    , "Budgie"
    , "Buffalo"
    , "Bull Mastiff"
    , "Bull Shark"
    , "Bullfrog"
    , "Bumblebee"
    , "Burmese"
    , "Butterfly"
    , "Fish"
    , "Caiman"
    , "Lizard"
    , "Canaan"
    , "Capybara"
    , "Caracal"
    , "Carolina"
    , "Cassowary"
    , "Cat"
    , "Caterpillar"
    , "Catfish"
    , "Centipede"
    , "Cesky"
    , "Fousek"
    , "Chameleon"
    , "Chamois"
    , "Cheetah"
    , "Chicken"
    , "Chihuahua"
    , "Chimpanzee"
    , "Chinchilla"
    , "Chinook"
    , "Chinstrap"
    , "Chipmunk"
    , "Chow Chow"
    , "Cichlid"
    , "Leopard"
    , "Clown Fish"
    , "Clumber"
    , "Coati"
    , "Cockroach"
    , "Collared Peccary"
    , "Buzzard"
    , "Frog"
    , "Loon"
    , "Erik"
    , "Jarnis"
    , "Toad"
    , "Coral"
    , "Cottontop"
    , "Tamarin"
    , "Cougar"
    , "Coyote"
    , "Crab"
    , "Macaque"
    , "Crane"
    , "Penguin"
    , "Crocodile"
    , "Cuscus"
    , "Cuttlefish"
    , "Dachshund"
    , "Dalmatian"
    , "Frog"
    , "Deer"
    , "Tortoise"
    , "Bracke"
    , "Dhole"
    , "Dingo"
    , "Discus"
    , "Doberman"
    , "Pinscher"
    , "Dodo"
    , "Dog"
    , "Dogo"
    , "Argentino"
    , "Dolphin"
    , "Donkey"
    , "Dormouse"
    , "Dragonfly"
    , "Drever"
    , "Duck"
    , "Dugong"
    , "Dunker"
    , "Dusky"
    , "Eagle"
    , "Earwig "
    , "Gorilla"
    , "Echidna"
    , "Mau"
    , "Eel"
    , "Seal"
    , "Shrew"
    , "Emu"
    , "Eskimo Dog"
    , "Falcon"
    , "Fennec"
    , "Ferret"
    , "Fin Whale"
    , "Spitz"
    , "Toad"
    , "Cat"
    , "Flamingo"
    , "Flounder"
    , "Fly"
    , "Flying Squirrel"
    , "Fossa"
    , "Fox Terrier"
    , "French Bulldog"
    , "Frigatebird"
    , "Frilled Lizard"
    , "Fur Seal"
    , "Galapagos Penguin"
    , "Galapagos Tortoise"
    , "Gar"
    , "Gecko"
    , "Gentoo Penguin"
    , "Gerbil"
    , "Gharial"
    , "Giant Clam"
    , "Gibbon"
    , "Gila Monster"
    , "Giraffe"
    , "Glass Lizard"
    , "Glow Worm"
    , "Goat"
    , "Oriole"
    , "Retriever"
    , "Goose"
    , "Gopher"
    , "Grasshopper"
    , "Great Dane"
    , "Grey Seal"
    , "Greyhound"
    , "Grizzly Bear"
    , "Grouse"
    , "Guinea Fowl"
    , "Guinea Pig"
    , "Guppy"
    , "Hammerhead"
    , "Shark"
    , "Hamster"
    , "Harrier"
    , "Havanese"
    , "Hedgehog"
    , "Hercules Beetle"
    , "Hermit Crab"
    , "Heron"
    , "Highland Cattle"
    , "Himalayan"
    , "Hippopotamus"
    , "Honey Bee"
    , "Horn Shark"
    , "Horned Frog"
    , "Horse"
    , "Horseshoe Crab"
    , "Howler Monkey"
    , "Human"
    , "Humboldt"
    , "Hummingbird"
    , "Humpback Whale"
    , "Hyena"
    , "Ibis"
    , "Ibizan Hound"
    , "Iguana"
    , "Impala"
    , "Indian Elephant"
    , "Indian Rhinoceros"
    , "Indochinese Tiger"
    , "Indri"
    , "Insect"
    , "Setter"
    , "WolfHound"
    , "Jack Russel"
    , "Jackal"
    , "Jaguar"
    , "Chin"
    , "Javanese"
    , "Jellyfish"
    , "Kakapo"
    , "Kangaroo"
    , "Killer Whale"
    , "King Crab"
    , "King Penguin"
    , "Kingfisher"
    , "Kiwi"
    , "Koala"
    , "Komodo Dragon"
    , "Kudu"
    , "Labradoodle"
    , "Labrador Retriever"
    , "Ladybird"
    , "Leaf-Tailed Gecko"
    , "Lemming"
    , "Lemur"
    , "Leopard Cat"
    , "Leopard Seal"
    , "Leopard Tortoise"
    , "Liger"
    , "Lion"
    , "Lionfish"
    , "Little Penguin"
    , "Llama"
    , "Lobster"
    , "Owl"
    , "Lynx"
    , "Macaroni Penguin"
    , "Macaw"
    , "Magpie"
    , "Maine Coon"
    , "Malayan Civet"
    , "Malayan Tiger"
    , "Maltese"
    , "Manatee"
    , "Mandrill"
    , "Manta Ray"
    , "Marine Toad"
    , "Markhor"
    , "Marsh Frog"
    , "Mastiff"
    , "Mayfly"
    , "Meerkat"
    , "Millipede"
    , "Minke Whale"
    , "Mole"
    , "Molly"
    , "Mongoose"
    , "Mongrel"
    , "Monitor"
    , "Monkey"
    , "Moorhen"
    , "Moose"
    , "Eel"
    , "Moray"
    , "Moth"
    , "Mountain Lion"
    , "Mouse"
    , "Mule"
    , "Neanderthal"
    , "Neapolitan"
    , "Newfoundland"
    , "Newt"
    , "Nightingale"
    , "Numbat"
    , "Nurse Shark"
    , "Ocelot"
    , "Octopus"
    , "Okapi"
    , "Olm"
    , "Opossum"
    , "Ostrich"
    , "Otter"
    , "Oyster"
    , "Pademelon"
    , "Panther"
    , "Parrot"
    , "Patas Monkey"
    , "Peacock"
    , "Pekingese"
    , "Pelican"
    , "Persian"
    , "Pheasant"
    , "Pied Tamarin"
    , "Pika"
    , "Pike"
    , "Piranha"
    , "Platypus"
    , "Pointer"
    , "Polar Bear"
    , "Pond Skater"
    , "Poodle"
    , "Pool Frog"
    , "Porcupine"
    , "Possum"
    , "Prawn"
    , "Proboscis Monkey"
    , "Puffer Fish"
    , "Puffin"
    , "Puma"
    , "Marmoset"
    , "Pygmy"
    , "Quail"
    , "Quetzal"
    , "Quokka"
    , "Quoll"
    , "Rabbit"
    , "Raccoon"
    , "Raccoon Dog"
    , "Ragdoll"
    , "Rattlesnake"
    , "Red Panda"
    , "Red Wolf"
    , "Reindeer"
    , "River Dolphin"
    , "River Turtle"
    , "Robin"
    , "Rock Hyrax"
    , "Rockhopper"
    , "Roseate Spoonbill"
    , "Rottweiler"
    , "Royal Penguin"
    , "Russian Blue"
    , "Sabre-Toothed Tiger"
    , "Saint Bernard"
    , "Salamander"
    , "Sand Lizard"
    , "Saola"
    , "Scorpion"
    , "Scorpion Fish"
    , "Sea Dragon"
    , "Sea Lion"
    , "Sea Otter"
    , "Sea Slug"
    , "Sea Squirt"
    , "Sea Turtle"
    , "Sea Urchin"
    , "Seahorse"
    , "Seal"
    , "Serval"
    , "Sheep"
    , "Shih Tzu"
    , "Shrimp"
    , "Siamese"
    , "Siberian"
    , "Siberian Husky"
    , "Siberian Tiger"
    , "Silver Dollar"
    , "Slow Worm"
    , "Snail"
    , "Snapping Turtle"
    , "Snowshoe"
    , "Snowy Owl"
    , "Somali"
    , "Spadefoot Toad"
    , "Sparrow"
    , "Spectacled Bear"
    , "Sperm Whale"
    , "Spider Monkey"
    , "Dogfish"
    , "Sponge"
    , "Squid"
    , "Squirrel"
    , "Squirrel Monkey"
    , "Stag Beetle"
    , "Starfish"
    , "Stickbug"
    , "Stingray"
    , "Stoat"
    , "Sun Bear"
    , "Swan"
    , "Tang"
    , "Tapir"
    , "Tarsier"
    , "Tasmanian Devil"
    , "Tawny Owl"
    , "Termite"
    , "Tetra"
    , "Thorny Devil"
    , "Tiffany"
    , "Tiger"
    , "Tiger Salamander"
    , "Tiger Shark"
    , "Tortoise"
    , "Toucan"
    , "Tree Frog"
    , "Tropicbird"
    , "Tuatara"
    , "Turkey"
    , "Uakari"
    , "Uguisu"
    , "Umbrellabird"
    , "Vampire Bat"
    , "Vervet Monkey"
    , "Vulture"
    , "Wallaby"
    , "Warthog"
    , "Wasp"
    , "Water Buffalo"
    , "Water Dragon"
    , "Water Vole"
    , "Weasel"
    , "Welsh Corgi"
    , "Whale Shark"
    , "Whippet"
    , "White Tiger"
    , "Wild Boar"
    , "Wildebeest"
    , "Wolverine"
    , "Wombat"
    , "Woodlouse"
    , "Woodpecker"
    , "Woolly Mammoth"
    , "Woolly Monkey"
    , "Wrasse"
    , "Yak"
    , "Yellow-Eyed Penguin"
    , "Yorkie"
    , "Yorkiepoo"
    , "Zebra"
    , "Zebra Shark"
    , "Zebu"
    , "Zonkey"
    , "Zorse"];
